import type { TypePolicies } from '@apollo/client';
import type { UploaderConfigEnum } from '../../generated';
import { uploaderConfigsMap } from './uploader-configs';

type UploaderConfigs = {
  [key in UploaderConfigEnum]?: number;
};

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      uploaderConfigs: () => {
        const configs: UploaderConfigs = {};
        uploaderConfigsMap.forEach((val, key) => {
          configs[key] = val;
        });
        return configs;
      },
    },
  },
};
